import { render, staticRenderFns } from "./WarningStudentLists.vue?vue&type=template&id=4b9555ce&"
import script from "./WarningStudentLists.vue?vue&type=script&lang=js&"
export * from "./WarningStudentLists.vue?vue&type=script&lang=js&"
import style0 from "./WarningStudentLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports